import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import naayaTrade from "../../../assets/homepage/enquiry/ntLogo.png"; // naayaTrade image
import successIcon from "../../../assets/homepage/enquiry/successIcon.png"; // successIcon Image
import untitled from "../../../assets/homepage/enquiry/Untitled.png";
import untitled2 from "../../../assets/homepage/enquiry/Untitled2.png";
import { rfqSubmitApi } from "../../../Apis/BuyerApi";
import SoundRecorder from "../AudioRecorder";
import { getAuth, onAuthStateChanged } from "@firebase/auth";
import ImgUploaded from "../../../assets/homepage/enquiry/Layer 2.jpg";
import {
  HomeInquiryDeleteSVG,
  QuotationAddSVG,
} from "../../../assets/svg/allSvg";

const Enquiry = () => {
  const [productName, setProductName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [orderValue, setOrderValue] = useState("");
  const [currency, setCurrency] = useState("INR");
  const [contactNumber, setContactNumber] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [type, setType] = useState("audio");

  const [user, setUser] = useState(null);
  const [files, setFiles] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  function handleFiles(event) {
    const selectedFiles = Array.from(event.target.files);

    // Combine existing files with new selected files, removing duplicates and maintaining order
    const combinedFiles = [...files, ...selectedFiles].reduce((acc, file) => {
      if (!acc.find((f) => f.name === file.name)) {
        acc.push(file);
      } else {
        // Move existing file to the end if it was re-selected
        acc = acc.filter((f) => f.name !== file.name);
        acc.push(file);
      }
      return acc;
    }, []);

    const newFiles = combinedFiles.slice(-4);

    setFiles(newFiles.reverse());
  }

  function handleUpload(event) {
    event.preventDefault();
    if (files.length === 0) return;

    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append(files, { i }, files[i]);
    }

    fetch("url", {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("success", result);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function handleDrop(event) {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);

    const limitedFiles = droppedFiles.slice(0, 4 - files.length);
    setFiles([...files, ...limitedFiles]);
  }

  function handleDelete(index) {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
  }

  const auth = getAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, [auth]);

  // RadioButton
  const [selectedOption, setSelectedOption] = useState("recordRequirement");
  const handleRadioBtnChange = (e) => {
    const optionSelected = e.target.value;
    setSelectedOption(optionSelected);

    const typeSelected =
      optionSelected === "recordRequirement" ? "audio" : "images";
    setType(typeSelected);
    setAttachments([]);
  };
  // RadioButton End

  const [showRfq1, setShowRfq1] = useState(true);
  const [showRfq2, setShowRfq2] = useState(false);
  const [showRfq3, setShowRfq3] = useState(false);

  const handleNextButtonClick = () => {
    if (!user) {
      navigate("/login");
    } else {
      setShowRfq1(false);
      setShowRfq2(true);
      setShowRfq3(false);
    }
  };
  const handleBackButtonClick = () => {
    setShowRfq1(true);
    setShowRfq2(false);
    setShowRfq3(false);
  };
  const handleSubmitButtonClick = async () => {
    let file = files;

    if (type == "audio") file = attachments;

    const data = {
      title,
      description,
      quantity,
      phoneNumber,
      amount,
      files: file,
      type,
    };

    const response = await rfqSubmitApi(data);

    if (response?.message === "New RFQ created") {
      setShowRfq1(false);
      setShowRfq2(false);
      setShowRfq3(true);
    }
  };
  const handleBacktoRequestsButtonClick = () => {
    setShowRfq1(true);
    setShowRfq2(false);
    setShowRfq3(false);
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    setAttachments([...attachments, ...Array.from(files)]);
  };

  // Function to remove an image from attachments
  const removeImage = (index) => {
    const newAttachments = [...attachments];
    newAttachments.splice(index, 1);
    setAttachments(newAttachments);
  };

  return (
    <div className="max-w-[1240px] mx-auto px-[16px] md:px-[24px] lg:px-0 mt-[24px] md:mt-[16px] lg:mt-[35px]">
      <div className="bg-[#FFFFFF] lg:w-[1240px] lg:h-[571px] w-[328px] h-[611px] md:w-full md:h-[689px] rounded-[10px] shadow-[0_0px_0px_2px_rgba(0,0,0,0.07)]">
        <div className="flex flex-col lg:flex-row md:items-center lg:items-start absolute lg:h-[571px] w-[328px] h-[611px] md:w-[720px] md:h-[689px] lg:w-[1240px]">
          <div className="rfq-box-left z-10 mt-[34px] lg:text-left md:text-center md:w-[612px] lg:w-[420px] mx-[54px] flex flex-col">
            <div className="md:w-[612px] flex items-center justify-center lg:items-start lg:justify-start lg:w-full">
              <img
                className="h-[54px] w-[171px]"
                src={naayaTrade}
                alt="naayaTrade"
              />
            </div>
            <div className="section-heading text-center lg:text-start h-[21px] md:text-[16px] md:h-[24px] lg:h-[36px] lg:text-[24px] md:font-bold font-semibold text-[14px] text-[#FF6300] md:mt-[8px] lg:mt-[35px] select-none">
              Request for Quotations
            </div>
            <div className="section-desc w-[272px] h-[18px] font-medium lg:font-semibold text-[12px] md:text-[14px] lg:text-[20px] md:w-[612px] lg:w-[405px] md:h-[21px] lg:h-[76px] md:mt-[8px] lg:mt-[25px] select-none">
              An easy way to send requests to all suppliers
            </div>
          </div>
          <div className="rfq-box-right flex flex-col z-10 relative bg-white lg:my-[32px] mr-[15px] rounded-[10px] h-[448px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] md:w-[437px] md:h-[480px] p-[11px] md:px-0 lg:w-[665px] lg:h-[511px] ml-[15px] mt-[22px] md:mt-[36px]">
            {/* rfq Step 1 */}
            {showRfq1 && (
              <>
                <div className="rfq-inputs md:my-[20px] md:mx-[16px] lg:mx-[24px] text-left flex flex-col">
                  <div className="hidden md:block text-[20px] font-semibold text-[#FF6300] leading-[28px] select-none">
                    Send Quotations
                  </div>
                  <div className="font-semibold text-[12px] md:text-[16px] lg:text-[20px] leading-[28px] md:mt-[35px] lg:mt-[20px] select-none">
                    Your Contact Number
                  </div>
                  <input
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    className="w-[275px] h-[36px] md:w-[405px] md:h-[54px] lg:w-full lg:h-[55px] rounded-[5px] border border-gray-300 mt-[4px] px-[16px] md:mt-[13px] lg:mt-[10px] placeholder:w-[283px] placeholder:h-[28px] placeholder:text-[14px] placeholder:text-[#C7C7C7] text-[14px] placeholder:font-semibold"
                    placeholder="Enter your Phone number"
                  />
                  <div className="font-semibold text-[12px] md:text-[16px] leading-[28px] mt-[17px] md:mt-[35px] lg:mt-[30px] select-none">
                    Personalise your enquiry (optional)
                  </div>
                  <div className="text-[12px] md:text-[14px] font-medium w-[248px] md:w-[420px] leading-[22px] md:mt-[4px] lg:mt-[10px] select-none">
                    Record your requirement or add related product images .
                  </div>
                  <div className="md:mt-[16px] lg:mt-[10px] mt-[10px] flex flex-col gap-y-[10px] md:gap-y-0 md:flex-row gap-x-[32px]">
                    <label className="flex items-center gap-x-[9px] font-medium text-[12px] md:text-[14px]">
                      <input
                        className="h-[28px]"
                        type="radio"
                        value="recordRequirement"
                        checked={selectedOption === "recordRequirement"}
                        onChange={handleRadioBtnChange}
                      />
                      Record requirement
                    </label>
                    <label className="flex items-center gap-x-[9px] font-medium text-[12px] md:text-[14px]">
                      <input
                        className="h-[28px]"
                        type="radio"
                        value="addImages"
                        checked={selectedOption === "addImages"}
                        onChange={handleRadioBtnChange}
                      />
                      Add Images , docs , sheets
                    </label>
                  </div>
                  {selectedOption === "recordRequirement" && (
                    <div className="w-[273px] h-[40px] md:w-[405px] lg:w-full lg:h-[55px] md:h-[54px] border border-black border-opacity-20 lg:rounded-[20px] rounded-[5px] md:rounded-[12px] mt-[30px] md:mt-[16px] lg:mt-[14px] py-[5px] px-[12px] md:py-[13px] md:px-[18px]">
                      <SoundRecorder
                        attachments={attachments}
                        selectedOption={selectedOption}
                      />
                    </div>
                  )}

                  {selectedOption === "addImages" && (
                    <div className="w-[596px] h-auto bg-white rounded-[5px] mt-[21px]">
                      <div className="flex flex-wrap gap-3 h-[60px] overflow-y-scroll">
                        {files.slice(0, 4).map((file, index) => (
                          <div
                            key={index}
                            className="w-[290px] border h-[60px] bg-white rounded-[5px] flex items-center py-[14px] pl-[15px] pr-[8px] justify-between"
                          >
                            <div className="flex items-center gap-x-[11px]">
                              <img
                                className="w-[24px] h-[24px]"
                                src={ImgUploaded}
                                alt={`Product ${index}`}
                              />
                              <p className="w-auto h-[18px] font-medium text-start text-black text-[12px]">
                                {file.name?.slice(0, 20)}
                              </p>
                            </div>
                            <button onClick={() => handleDelete(index)}>
                              <div className="">{HomeInquiryDeleteSVG}</div>
                            </button>
                          </div>
                        ))}

                        {files.length < 4 && (
                          <div className="w-auto bg-white rounded-[5px] py-[8px] flex items-center">
                            <form onSubmit={handleUpload} className="">
                              <div
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={handleDrop}
                              >
                                <input
                                  multiple
                                  type="file"
                                  accept="image/*,application/pdf"
                                  name="file"
                                  onChange={handleFiles}
                                  className="hidden"
                                />
                                <button
                                  type="button"
                                  onClick={() =>
                                    document
                                      .querySelector("input[type=file]")
                                      .click()
                                  }
                                  className="flex items-center gap-x-[14px]"
                                >
                                  <p className="w-[35px] h-[35px] bg-[#FF6300] text-white flex items-center justify-center font-semibold text-[20px] rounded-[4px]">
                                    {QuotationAddSVG}
                                  </p>
                                </button>
                              </div>
                            </form>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div className="btn-div h-[46px] flex items-center justify-center  mt-[79px] md:mt-0 lg:mt-[34px]">
                  <button
                    type="Submit"
                    onClick={handleNextButtonClick}
                    className="next-button w-[273px] h-[40px] md:w-[111px] md:h-[46px] bg-[#FF6300] rounded-[5px] md:rounded-[10px] text-white font-semibold text-[12px] md:text-[16px] flex items-center justify-center"
                  >
                    Next
                  </button>
                </div>
              </>
            )}

            {showRfq2 && (
              <div className="rfq-step-2">
                <div className="rfq-inputs my-[20px] mx-[24px] text-left flex flex-col">
                  <div className="text-[20px] font-semibold text-[#FF6300] leading-[28px] select-none">
                    Request for Quotations
                  </div>
                  <div className="text-[16px] font-semibold leading-[28px] mt-[20px] select-none">
                    Provide more details
                  </div>

                  <input
                    onChange={(e) => setTitle(e.target.value)}
                    className="w-[596px] h-[55px] rounded-[5px] border border-gray-300 px-[16px] mt-[10px] placeholder:w-[283px] placeholder:h-[28px] placeholder:text-[14px] placeholder:text-[#C7C7C7] text-[14px] placeholder:font-semibold"
                    placeholder="Name of the product you are looking for"
                  />

                  <input
                    onChange={(e) => setDescription(e.target.value)}
                    className="w-[596px] resize-none h-[120px] py-[16px] rounded-[5px] border border-gray-300 px-[16px] mt-[10px] placeholder:w-[283px] placeholder:h-[28px] placeholder:text-[14px] placeholder:text-[#C7C7C7] text-[14px] placeholder:font-semibold"
                    placeholder="Description"
                  />

                  <input
                    onChange={(e) => setQuantity(e.target.value)}
                    className="w-[596px] h-[55px] rounded-[5px] border border-gray-300 px-[16px] mt-[10px] placeholder:w-[283px] placeholder:h-[28px] placeholder:text-[14px] placeholder:text-[#C7C7C7] text-[14px] placeholder:font-semibold"
                    placeholder="Quantity"
                    type="number"
                  />
                  <input
                    onChange={(e) => {
                      const value = Math.max(1, e.target.value);
                      setAmount(value);
                    }}
                    value={amount}
                    className="w-[596px] h-[55px] rounded-[5px] border border-gray-300 px-[16px] mt-[10px] placeholder:w-[283px] placeholder:h-[28px] placeholder:text-[14px] placeholder:text-[#C7C7C7] text-[14px] placeholder:font-semibold"
                    placeholder="Amount"
                    type="number"
                  />
                </div>
                <div className="w-full flex items-center justify-center mt-[25px] mb-[10px] gap-x-[40px]">
                  <button
                    onClick={handleBackButtonClick}
                    className="w-[80px] h-[46px] text-[#FF9653] rounded-[10px] border border-black border-opacity-25 font-semibold"
                  >
                    Back
                  </button>
                  <button
                    onClick={handleSubmitButtonClick}
                    className="bg-[#FF6300] text-white w-[133px] h-[46px] text-[16px] rounded-[10px] font-semibold"
                  >
                    Submit
                  </button>
                </div>
              </div>
            )}
            {/* rfq Step 3 */}
            {showRfq3 && (
              <div className="rfq-step-3">
                <div className="my-[20px] mx-[24px] text-center">
                  <div className="text-[20px] font-[600] leading-[28px] mt-[90px]">
                    Congrats !!
                  </div>
                  <img
                    className="mx-auto w-[108px] h-[108px] mt-[60px]"
                    src={successIcon}
                    alt="successIcon"
                  ></img>
                  <div className="text-[18px] font-[600] leading-[28px] mt-[60px]">
                    Your quotation has been sent.
                  </div>
                </div>
                <div className="btn-div absolute py-[20px] bottom-0 w-[100%]">
                  <button
                    type="Submit"
                    onClick={handleBacktoRequestsButtonClick}
                    className="next-button flex items-center justify-center gap-x-[2px] w-[200px] h-[40px] bg-[#FFFFFF] rounded-[10px] text-[#000000] font-[600] text-[16px] leading-[28px] m-[10px] shadow mx-auto"
                  >
                    <div className="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="w-5 h-5"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                    <button
                      onClick={handleBacktoRequestsButtonClick}
                      className="bg-[#FF6300] text-white py-[10px] px-[20px] rounded-[5px] font-semibold"
                    >
                      Back to Requests
                    </button>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* <div> */}
        <img
          src={untitled2}
          className="lg:h-[571px] lg:w-[977px] relative w-[523px] h-[328px] md:w-[521px] md:h-[720px] md:-right-[100px] lg:right-0 lg:top-0 md:-top-[100px] z-0 rotate-90 lg:rotate-0 rounded-[10px] "
          alt="untitled img"
        />
        {/* </div> */}
      </div>
    </div>
  );
};

export default Enquiry;
